<template>
  <layout>
    <template slot="header">
      <pitaya-header />
    </template>
    <template slot="main">
      <router-view />
    </template>
    <template slot="side-navbar">
      <side-navbar></side-navbar>
    </template>
  </layout>
</template>

<script>
import Header from "../../components/Header";
import SideNavBar from "../../components/SideNavBar";
import Layout from "../../components/Layout";
import { mapActions, mapGetters } from "vuex";
import { PAYMENT_METHODS } from "@/config/constants";
import {
  addMakePaymentEvent,
  removeMakePaymentEvent,
  addAddPaymentMethodEvent,
  removeAddPaymentMethodEvent,
  addRemovePaymentMethodEvent,
  removeRemovePaymentMethodEvent,
} from "@/utils/events";

export default {
  components: {
    layout: Layout,
    "pitaya-header": Header,
    "side-navbar": SideNavBar,
  },
  computed: {
    ...mapGetters(["getVendor"]),
  },
  created() {
    // addMakePaymentEvent(this.onMakePayment);
    addAddPaymentMethodEvent(this.onAddPaymentMethod);
    addRemovePaymentMethodEvent(this.onRemovePaymentMethod);

    // Only load data if user is authenticated
    if (!this.$store.getters.isAuthenticated) {
      console.warn("[Dashboard] User not authenticated, skipping data fetch");
      return;
    }

    // Load these in the order of use/visualization
    this.$store.dispatch("fetchAccommodations");
    this.$store.dispatch("fetchBookings");
    this.$store.dispatch("getContacts");
    this.$store.dispatch("fetchPaymentTypes");
    this.$store.dispatch("getItems");
    this.$store.dispatch("getChannexStatus");

    this.$store.dispatch("getVendorData").then((vendor) => {
      if (vendor.stripe_id && vendor.stripe_location_id) {
        this.$store
          .dispatch("connectToStripeTerminal")
          .then((terminal) => {
            return this.$store.dispatch("initializeStripeTerminal", terminal);
          })
          .then((res) => {
            this.$store
              .dispatch("discoverReaders")
              .then((reader) => {
                this.infoNotification(`Connected to reader: ${reader.label}`);
              })
              .catch((err) => {
                this.errorNotification(err);
              });
          })
          .catch((error) => {
            this.errorNotification(`Failed to connect to reader`);
          });
      }
      // this.triggerEvent();
    });
  },

  beforeDestroy() {
    // removeMakePaymentEvent(this.onMakePayment);
    removeAddPaymentMethodEvent(this.onAddPaymentMethod);
    removeRemovePaymentMethodEvent(this.onRemovePaymentMethod);
  },

  methods: {
    ...mapActions(["addPaymentMethod", "removePaymentMethod"]),
    onAddPaymentMethod(event) {
      console.log("onAddPaymentMethod: ", event);
      const event_data = event.detail;
      if (!event_data || !event_data.label) {
        return "";
      }

      this.addPaymentMethod({
        text: event_data.label,
        value: PAYMENT_METHODS.IOS_TERMINAL,
      });
    },
    onRemovePaymentMethod(event) {
      console.log("onRemovePaymentMethod: ", event);
      const event_data = event.detail;
      if (!event_data || !event_data.label) {
        return "";
      }

      this.removePaymentMethod({
        text: event_data.label,
        value: PAYMENT_METHODS.IOS_TERMINAL,
      });
    },
    // TODO for test
    onMakePayment(event) {
      console.log("Make Payment Event: ", event.detail);
      let event_data = event.detail;
      let event_new = new CustomEvent("payment_completed", {
        detail: {
          ...event_data,
          success: true,
        },
      });

      setTimeout(() => {
        window.dispatchEvent(event_new);
      }, 3000);
    },
    // TODO for test
    triggerEvent() {
      let event = new CustomEvent("add_payment_method", {
        detail: {
          label: "iOS Terminal",
        },
      });
      window.dispatchEvent(event);
    },
  },
};
</script>

<style></style>
